import { logger } from 'lib/logger';
import { PROMO_TARIFFS } from 'reactApp/appHelpers/configHelpers';
import { quotaLandingPromoButtonTariff } from 'reactApp/appHelpers/featuresHelpers';
import { enabledExpensivePlanTrial, expensivePlanTariffIds } from 'reactApp/appHelpers/featuresHelpers/features/forceTrial';
import {
    isPriceDifferentiation,
    priceDiffTariffHeaderDesktop,
    priceDiffTariffHeaderTouch,
} from 'reactApp/appHelpers/featuresHelpers/features/priceDifferentiation';
import {
    enablePersonalizationTopButtonTariff,
    personalizationTopButtonTariff,
    personalizationTopButtonTariffTouch,
} from 'reactApp/appHelpers/featuresHelpers/features/PromoQuotaPersonalization';
import type { Product } from 'reactApp/types/Billing';
import { sendXray } from 'reactApp/utils/ga';
import { captureException } from 'reactApp/utils/tracer';

interface getProductIdProps {
    isMobile: boolean;
    paidUserProduct?: Product;
    desktopTariff?: string | false;
}

export const PROMO_BUTTON_QUERY_ID = 'lp-product-id';

const getProductIdFromQuery = (): string | null => {
    try {
        const urlParams = new URLSearchParams(window.location.search);

        return urlParams.get(PROMO_BUTTON_QUERY_ID);
    } catch (error) {
        sendXray('product-id-query-failure');
        captureException(error, { issueKey: 'ProductId: query fetch failure' });
        logger.error(error);

        return null;
    }
};

export const getProductId = ({ isMobile, paidUserProduct, desktopTariff }: getProductIdProps): string => {
    if (enablePersonalizationTopButtonTariff) {
        return isMobile ? personalizationTopButtonTariffTouch : personalizationTopButtonTariff;
    } else if (isPriceDifferentiation) {
        return isMobile ? priceDiffTariffHeaderTouch : priceDiffTariffHeaderDesktop;
    } else if (enabledExpensivePlanTrial) {
        return expensivePlanTariffIds.year;
    }

    const productFromQuery = getProductIdFromQuery();
    if (productFromQuery) {
        return productFromQuery;
    }

    return paidUserProduct?.id || quotaLandingPromoButtonTariff || desktopTariff || PROMO_TARIFFS?.quotaLandingMenu;
};
